import {
  PRODUCT_TRANSACTION_EXPORT_LOG_ALL,
  PRODUCT_TRANSACTION_EXPORT_LOG_GET,
  PRODUCT_TRANSACTION_EXPORT_LOG_LOADING,
  PRODUCT_TRANSACTION_EXPORT_LOG_ERROR,
  PRODUCT_TRANSACTION_EXPORT_LOG_RESET,
  // eslint-disable-next-line import/named
} from '../../actions/types';

const initialState = {
  productTransactionExport: null,
  isLoading: true,
  isCompleted: false,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case PRODUCT_TRANSACTION_EXPORT_LOG_LOADING:
      return { isLoading: true, isCompleted: false };
    case PRODUCT_TRANSACTION_EXPORT_LOG_RESET:
      return { isLoading: true, isCompleted: false, ...action.payload };
    case PRODUCT_TRANSACTION_EXPORT_LOG_ERROR:
      return { isLoading: true, isCompleted: false, ...action.payload };
    case PRODUCT_TRANSACTION_EXPORT_LOG_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PRODUCT_TRANSACTION_EXPORT_LOG_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    default:
      return state;
  }
}
